import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    margin: '0 auto',
    padding: '30px 30px 50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '40px',
    [theme.breakpoints.up('md')]: {
      rowGap: '80px',
      padding: '60px 75px 75px',
    },
  },

  container: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: '65px',
    },
    [theme.breakpoints.up('lg')]: {
      columnGap: '100px',
    },
  },

  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },

    //TODO: after festival buttom remove then remove below css

    [theme.breakpoints.up(1330)]: {
      width: '730px',
    },
  },

  dTImgWrapper: {
    flexShrink: '0',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  imgWrapper: {
    flexShrink: '0',
    position: 'relative',
    width: '240px',
    marginTop: '18px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  description: {
    marginTop: '18px',
    maxWidth: '650px',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },

  btnWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    columnGap: '15px',
    rowGap: '10px',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },

  btnTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: '15px',

    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },
  },
});
